<template>
  <div class="BjKanBan">
    <h1 style="text-align:center; margin: 0vh 0vh 2vh 0; line-height: 8vh;">
      部件仓电子看板
    </h1>
    <div style="width: 100%;">
      <div style="display: flex;flex-direction: row;align-items: center">
        <div style="width: 30%;">
          <div class="timeText">
            <div>本年</div>
            <div class="timeText-num">
              <div v-for="(item,index) in currentYearNumList" :key="index" class="timeText-num-img">{{item}}</div>
            </div>
          </div>
        </div>
        <div style="width: 30%;">
          <div class="timeText">
            <div>本月</div>
            <div class="timeText-num">
              <div v-for="(item,index) in currentMonthNumList" :key="index" class="timeText-num-img">{{item}}</div>
            </div>
          </div>
        </div>
        <div style="width: 30%;">
          <div class="timeText">
            <div>本日</div>
            <div class="timeText-num">
              <div v-for="(item,index) in currentDayNum" :key="index" class="timeText-num-img">{{item}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 1vh 10px;height: 36vh">
      <div style="width: 50%; float: left;position: relative;height: 38vh;background-color: #2D4054;">
        <div class="wordBox" style="position: absolute;top: 12vh;left: 6vh;width: 50%;z-index: 999;">
          <div style="font-size:1.5em;text-align:left">
            <div>
              当日计划(按单数)：
              <span style="font-size: 1.25em">
                {{kzgKanBanVO.currentDayPlanNum}}
              </span>
            </div> 
            <div>
              当日完成(按单数)：
              <span style="font-size: 1.25em">
                {{kzgKanBanVO.currentDayFinishNum}}
              </span>
            </div>
          </div>
        </div>
        <div class="chart1" style="width: 100%; height: 36vh;margin-left:12vw;"/>
      </div>
      <div style="width: 50%; float: left;position: relative;height: 38vh;background-color: #2D4054;">
        <div class="wordBox" style="position: absolute;top: 12vh;left: 6vh;width: 50%;z-index: 999;">
          <div style="font-size:1.5em;text-align:left">
            <div>
              当日计划(按台数)：
              <span style="font-size: 1.25em">
                {{kzgKanBanVO.slCurrentDayPlanNum}}
              </span>
            </div>
            <div>
              当日完成(按台数)：
              <span style="font-size: 1.25em">
                {{kzgKanBanVO.slcurrentDayFinishNum}}
              </span>
            </div> 
          </div>
        </div>
        <div class="chart2" style="width: 100%; height: 36vh;margin-left:12vw;"/>
      </div>
    </div>
    <div style="margin: 2vh 10px 0 10px;background: #2D4054;">
      <div class="chart3" style="width: 100%; height: 39vh;"/>
    </div>
  </div>
</template>

<script>
  import "echarts-liquidfill";
  export default {
    data() {
      return {
        myChart1: null,
        myChart3: null,
        kzgKanBanVO: {
          currentYearNum: 0,
          currentMonthNum: 0,
          currentDayNum: 0,
          currentDayPlanNum: 0,
          currentDayFinishNum: 0,
        },
        lastDayPlan: 0,
        lastDayDone: 0,
        todayPlan: 0,
        todayDone: 0,
        currentYearNumList: [],
        currentMonthNumList: [],
        currentDayNum: [],
      };
    },
    mounted() {
      this.getKGList();
      this.myChart1 = this.$echarts.init(document.querySelector(".chart1"));
      this.myChart2 = this.$echarts.init(document.querySelector(".chart2"));
      this.myChart3 = this.$echarts.init(document.querySelector(".chart3"));
      setInterval(() => {
        this.getKGList();
      }, 1000 * 60 * 20);
    },
    methods: {
      getKGList() {
        var type ="Bj";
        this.$http.get("basic",`kanban/getWareHouseKanBanVO/${type}`).then(res => {
          this.kzgKanBanVO = res;
          console.log(this.kzgKanBanVO);
          if(this.kzgKanBanVO.currentYearNum > 0) {
            let s = ""+this.kzgKanBanVO.currentYearNum;
            let s2 = ""+this.kzgKanBanVO.currentMonthNum;
            let s3 = ""+this.kzgKanBanVO.currentDayNum;
            this.currentYearNumList = [];
            this.currentMonthNumList = [];
            this.currentDayNum = [];
            for(let i=0;i<s.length;i++) {
              this.currentYearNumList.push(s[i]);
            }
            for(let i=0;i<s.length-s2.length;i++) {
              this.currentMonthNumList.push("0");
            }
            for(let i=0;i<s.length-s3.length;i++) {
              this.currentDayNum.push("0");
            }
            for(let i=0;i<s2.length;i++) {
              this.currentMonthNumList.push(s2[i]);
            }
            for(let i=0;i<s3.length;i++) {
              this.currentDayNum.push(s3[i]);
            }
            console.log(this.currentYearNumList);
            console.log(this.currentMonthNumList);
            console.log(this.currentDayNum);
          }
          this.$nextTick(() => {
            this.setOptions1();
            this.setOptions2();
            this.setOptions3();
          });
        });
      },
      setOptions1() {
        this.myChart1.setOption({
          backgroundColor: "#2D4054",
          title: [
            {
              text: "\n当日出料数(按单数)\n",
              left: "left",
              top:"5",
              textStyle: {
                fontWeight: "normal",
                fontSize: this.fontSize(0.25),
                color: "#3fecff",
              },
            },
          ],
          series: [{
            type: "liquidFill",
            radius: "50%",
            data: [this.kzgKanBanVO.currentDayFinishNum/this.kzgKanBanVO.currentDayPlanNum,this.kzgKanBanVO.slcurrentDayFinishNum/this.kzgKanBanVO.slCurrentDayPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "#2d5478",
              color: "#2d4059",
            },
            label: {
              normal: {
                formatter: this.chartValueFormatter(this.kzgKanBanVO.currentDayFinishNum, this.kzgKanBanVO.currentDayPlanNum) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.4),
                  color: "#fdd100",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "#2d5478",
              },
            },
          }],
        });
      },
      setOptions2() {
        this.myChart2.setOption({
          backgroundColor: "#2D4054",
          title: [
            {
              text: "\n当日出料数(按台数)\n",
              left: "left",
              top:"5",
              textStyle: {
                fontWeight: "normal",
                fontSize: this.fontSize(0.25),
                color: "#3fecff",
              },
            },
          ],
          series: [{
            type: "liquidFill",
            radius: "50%",
            data: [this.kzgKanBanVO.slcurrentDayFinishNum/this.kzgKanBanVO.slCurrentDayPlanNum,this.kzgKanBanVO.currentDayFinishNum/this.kzgKanBanVO.currentDayPlanNum],
            backgroundStyle: {
              borderWidth: this.fontSize(0.05),
              borderColor: "#2d5478",
              color: "#2d4059",
            },
            label: {
              normal: {
                formatter: this.chartValueFormatter(this.kzgKanBanVO.slcurrentDayFinishNum, this.kzgKanBanVO.slCurrentDayPlanNum) + "%",
                textStyle: {
                  fontSize: this.fontSize(0.4),
                  color: "#fdd100",
                },
              },
            },
            outline: {
              borderDistance: 0,
              itemStyle: {
                borderWidth: this.fontSize(0.05),
                borderColor: "#2d5478",
              },
            },
          }],
        });
      },
      setOptions3() {
        this.myChart3.setOption({
          title:{
            text:" 仓库出料小时产出数",
            textStyle: {
              fontWeight: "normal",
              color: "RGB(255,255,255)",
            },
          },
          legend: {
            data: ["实际小时产出", "标准小时产出"],
            textStyle: {  // 图列内容样式
              color: "#fff",  // 字体颜色
              //backgroundColor: "black",  // 字体背景色
            },
            right: 60,
          },          // ---  提示框 ----
          tooltip: {
            show: true,   // 是否显示提示框，默认为true
            trigger: "item", // 数据项图形触发
            axisPointer: {   // 指示样式
              type: "shadow",
              axis: "auto",
            },
            padding: 5,
            textStyle: {   // 提示框内容的样式
              color: "#fff",
            },
          },
          // ---- gird区域 ---
          gird: {
            show: false,    // 是否显示直角坐标系网格
            top: 80,  // 相对位置 top\bottom\left\right
            containLabel: false, // gird 区域是否包含坐标轴的刻度标签
            tooltip: {
              show: true,
              trigger: "item",   // 触发类型
              textStyle: {
                color: "#666",
              },
            },
          },
          //  ------  X轴 ------
          xAxis: {
            show: true,  // 是否显示
            position: "bottom",  // x轴的位置
            offset: 0, // x轴相对于默认位置的偏移
            type: "category",   // 轴类型， 默认为 'category'
            name: "时间",    // 轴名称
            nameLocation: "end",  // 轴名称相对位置
            nameTextStyle: {   // 坐标轴名称样式
              color: "white",
              padding: [5, 0, 0, -5],
            },
            nameGap: 15, // 坐标轴名称与轴线之间的距离
            nameRotate: 0,  // 坐标轴名字旋转
            axisLine: {       // 坐标轴 轴线
              show: true,  // 是否显示
              symbol: ["none", "arrow"],  // 是否显示轴线箭头
              symbolSize: [8, 8], // 箭头大小
              symbolOffset: [0, 7],  // 箭头位置
              // ------   线 ---------
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            axisTick: {    // 坐标轴 刻度
              show: false,  // 是否显示
              inside: true,  // 是否朝内
              length: 3,     // 长度
              lineStyle: {   // 默认取轴线的样式
                color: "#fff",
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {    // 坐标轴标签
              show: true,  // 是否显示
              inside: false, // 是否朝内
              rotate: 0, // 旋转角度
              margin: 5, // 刻度标签与轴线之间的距离
              color: "#fff",  // 默认取轴线的颜色
            },
            splitLine: {    // gird区域中的分割线
              show: false,  // 是否显示
              lineStyle: {
                // color: 'red',
                // width: 1,
                // type: 'solid'
              },
            },
            splitArea: {    // 网格区域
              show: false,  // 是否显示，默认为false
            },
            data: this.kzgKanBanVO.hourList,
          },
          //   ------   y轴  ----------
          yAxis: {
            show: true,  // 是否显示
            position: "left", // y轴位置
            offset: 0, // y轴相对于默认位置的偏移
            type: "value",  // 轴类型，默认为 ‘category’
            name: "(台)",   // 轴名称
            nameLocation: "end", // 轴名称相对位置value
            nameTextStyle: {    // 坐标轴名称样式
              color: "#fff",
              padding: [5, 0, 0, 5],  // 坐标轴名称相对位置
            },
            nameGap: 15, // 坐标轴名称与轴线之间的距离
            nameRotate: 0,  // 坐标轴名字旋转

            axisLine: {    // 坐标轴 轴线
              show: true,  // 是否显示
              //  -----   箭头 -----
              symbol: ["none", "arrow"],  // 是否显示轴线箭头
              symbolSize: [8, 8],  // 箭头大小
              symbolOffset: [0, 7], // 箭头位置

              // ----- 线 -------
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            axisTick: {      // 坐标轴的刻度
              show: false,    // 是否显示
              inside: true,  // 是否朝内
              length: 3,      // 长度
              lineStyle: {
                color: "#fff",  // 默认取轴线的颜色
                width: 1,
                type: "solid",
              },
            },
            axisLabel: {      // 坐标轴的标签
              show: true,    // 是否显示
              inside: false,  // 是否朝内
              rotate: 0,     // 旋转角度
              margin: 8,     // 刻度标签与轴线之间的距离
              color: "#fff",  // 默认轴线的颜色
            },
            splitLine: {    // gird 区域中的分割线
              show: true,   // 是否显示
              lineStyle: {
                color: "#85afcb",
                width: 1,
                type: "solid",
              },
            },
            splitArea: {     // 网格区域
              show: false,   // 是否显示，默认为false
            },
          },
          series: [
            {
              name: "实际小时产出",
              type: "line",
              color: "#e768ef",
              // 设置折线上圆点大小
              symbolSize:7,
              // 设置拐点为实心圆
              symbol:"circle",
              data: this.kzgKanBanVO.numList,
            },
            {
              name: "标准小时产出",
              type: "line",
              color:"#e9ff2c",
              // 设置折线上圆点大小
              symbolSize:7,
              // 设置拐点为实心圆
              symbol:"circle",
              data: ["20","20","20","20","20","20","20","20","20","20","20","20","20","20"],
            },
          ],
        });
      },
      chartValueFormatter(value1, value2) {
        if (value1 == 0 || value2 == 0) {
          return 0;
        }
        return Math.round(value1 * 100/value2);
      },
      fontSize(res) {
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = 100 * (clientWidth / 1920);
        return res*fontSize;
      },
    },
  };
</script>

<style lang="scss">
  .BjKanBan {
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    background: url("/img/kanban_bg.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    text-align: center;
    color: #ffffff;
    .el-table, .el-table__expanded-cell, .el-table th, .el-table tr{
      background-color: transparent!important;
      color: #fff;
    }
    ::-webkit-scrollbar, ::-webkit-scrollbar-track {
      background-color: transparent!important;
    }
    .el-table__body tr:hover>td{
      background-color: #263445!important;
    }
    .el-table__body tr.current-row>td{
      background-color: #263445!important;
    }
    .clear{
      clear:both
    }
    .timeText{
      font-family: Arial-BoldMT;
      font-size: 4vh;
      line-height: 7vh;
      color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      //margin-bottom: 1vh;
      div{
        width: 50%;
        text-align: right;
      }
      .timeText-num{
        position: relative;
        display: flex;
        flex-direction: row;
        .timeText-num-img{
          width: 5vw;
          height: 9vh;
          line-height: 9vh;
          text-align: left;
          display: block;
          font-size: 7vh;
          color: #81C3FF;
          letter-spacing: 0.267vh;
          margin-left: 3%;
          background: url("../../../public/img/numbg.png") no-repeat;
          background-size: 100% 100%;
          text-align: center;
        }
      }

    }
  }
</style>